import React from "react";
import "../../css/MainPage/MainLanding.css";
import tools1 from "../../assets/header-images/tools1.jpg";
import assistant from "../../assets/header-images/assitant.jpg";
import tracker from "../../assets/header-images/tracker.jpg";
import gpas from "../../assets/header-images/gpa.jpg";
import earlysearch from "../../assets/header-images/earlysearch.jpg";
import rob1 from "../../assets/header-images/rob1.jpg";

const trafficBoxData = [
  {
    partNumber: "1",
    title: "Aza (AI Chatbot)",
    description:
      "Aza is your personalized AI Chatbot, designed to help you with a variety of tasks, including writing essays, applying to colleges, and tracking your academic progress. Whether you need guidance on school recommendations, improving your academic profile, or financial aid, Aza is here to provide tailored advice based on your personal data.",
    image: rob1,
    link: "/tools/ai",
  }, 
  {
    partNumber: "2",
    title: "Early Career Search",
    description:
      "Kickstart your professional journey with our Early Career Search Tool. Whether you're looking for internships, apprenticeships, or entry-level opportunities, this tool helps you find positions that match your skills and career goals.",
    image: earlysearch,
    link: "/tools/early-career-search",
  },
  // {
  //   partNumber: "3",
  //   title: "Financial Tracker",
  //   description:
  //     "Manage your college expenses effectively with our Financial Tracker. This tool allows you to track your family contributions, scholarships, loans, and other financial aid, as well as your expenses such as tuition, books, and housing. Stay on top of your budget and make informed financial decisions as you navigate your college journey.",
  //   image: tracker,
  //   link: "/tools/financial-tracker",
  // },
  // {
  //   partNumber: "4",
  //   title: "GPA Calculator",
  //   description:
  //     "A handy tool for calculating your GPA. Includes detailed instructions on how to input your grades and credits to accurately determine your grade point average, helping you stay on top of your academic performance.",
  //   image: gpas,
  //   link: "/tools/gpa-calculator",
  // },
  {
    partNumber: "5",
    title: "College Search",
    description:
      "This tool is currently under development and will be available soon. We're working hard to bring you this exciting new feature, so stay tuned for updates! Thank you for your patience and understanding as we work to enhance your experience.",
    image: tools1,
    link: "/tools/college-search",
  },
  {
    partNumber: "6",
    title: "Scholarship Search",
    description:
      "This tool is currently under development and will be available soon. We're working hard to bring you this exciting new feature, so stay tuned for updates! Thank you for your patience and understanding as we work to enhance your experience.",
    image: tools1,
    link: "/tools/scholarship-search",
  },
  {
    partNumber: "7",
    title: "Virtual College Tour",
    description:
      "This tool is currently under development and will be available soon. We're working hard to bring you this exciting new feature, so stay tuned for updates! Thank you for your patience and understanding as we work to enhance your experience.",
    image: tools1,
    link: "/tools/virtual-tour",
  },
  {
    partNumber: "8",
    title: "International Students Tool",
    description:
      "This tool is currently under development and will be available soon. We're working hard to bring you this exciting new feature, so stay tuned for updates! Thank you for your patience and understanding as we work to enhance your experience.",
    image: tools1,
    link: "/tools/international-students-tool",
  },
];

const introText =
  "This page is designed to provide you with comprehensive information about various tools and programs that can enhance your college experience and support your academic and professional growth. From AI-driven assistance to financial tracking, and from research opportunities to government programs, you'll find resources here that will help you succeed in your educational journey. Click on each category to explore detailed information and learn how you can benefit from these tools.";

const Tools = () => {
  return (
    <div className="main-landing-page">
      {/* Hero Section */}
      <div
        className="main-landing-hero"
        style={{ backgroundImage: `url(${tools1})` }}
      >
        <div className="main-landing-hero-overlay" />
        <div className="main-landing-hero-content">
          <h1>Tools</h1>
          <div className="main-landing-hero-sub">
            Discover tools to support your academic and financial journey.
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="main-landing-mission-section">
        <div className="main-landing-mission-container">
          <p>{introText}</p>
        </div>
      </div>

      {/* Main Sections */}
      <div style={{ background: "#f8fafc", padding: "3.5rem 0" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
            gap: "2.2rem",
            maxWidth: 1100,
            margin: "0 auto",
            padding: "0 1.5rem",
          }}
        >
          {trafficBoxData.map((box, idx) => (
            <a
              key={idx}
              href={box.link}
              className="afford-college-card"
              style={{ textDecoration: "none" }}
            >
              <div className="afford-college-card-image">
                <img src={box.image} alt={box.title} />
              </div>
              <div className="afford-college-card-content">
                <div>
                  <div className="afford-college-card-title">{box.title}</div>
                  <div className="afford-college-card-desc">
                    {box.description}
                  </div>
                </div>
                <div
                  className="afford-college-link-btn"
                  style={{ width: "fit-content" }}
                >
                  Learn More
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tools;
